module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1oSko"))).then(() => module.bundle.root('i9wCe'));